module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_3009.b7577865.png";